<template>
  <main v-if="webform">
    <PageHeader :title="webform.label" :subtitle />
    <section class="section">
      <Webform
        :webform
        class="container"
        :source-entity-id
        :source-entity-type
      />
    </section>
  </main>
</template>

<script setup lang="ts">
const { entity: node, metatags } = await useDrupalRouteQuery('webform')
const webformId = node.value?.id

if (!webformId) {
  throw new Error('Webform ID not found in the route query')
}

const sourceEntityId = useQueryString('source_entity_id')
const sourceEntityType = useQueryString('source_entity_type')
const webformQuery = await useAsyncGraphqlQuery('webformById', {
  id: webformId,
  sourceEntityId: sourceEntityId.value,
  sourceEntityType: sourceEntityType.value,
})
const webform = computed(() => webformQuery.data.value?.data.webformById)
const subtitle = computed(() => webform.value?.form?.sourceEntityLabel)

/* eslint-disable  @typescript-eslint/no-explicit-any */
useLogo().setLogoThemeFragment(node as any)
// The generic type V for the fragment can't be made compatible with these
// argument type, which is why we have to cast is as any here (which is fine).
/* eslint-disable  @typescript-eslint/no-explicit-any */
usePageTracking(node as any, metatags)
/* eslint-disable  @typescript-eslint/no-explicit-any */
setActiveChannel(node as any)

await renderPageDependencies()
</script>
